<template>
  <div>
    <!-- Toast components -->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />

    <!-- Heading and Add Button -->
    <v-row class="d-flex justify-space-between" flat>
      <v-col md="6" sm="6">
        <h1 class="heading-1">Study Groups & Events</h1>
      </v-col>
      <v-col md="6" sm="6">
        <v-card flat class="d-flex justify-end mt-2">
          <v-btn color="primary" dark class="text_style px-7" depressed @click="addEventDialog = true">
            Add new
          </v-btn>
          <v-dialog v-model="addEventDialog" max-width="600" persistent scrollable>
            <v-card v-if="addEventDialog">
              <EventAndGroupComponent :addEventDialog="addEventDialog" @close="handleClose" />
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>

    <!-- Search and Filter -->
    <v-row class="mt-6">
      <v-col cols="12" md="4" sm="6">
        <v-card flat>
          <v-text-field dense outlined prepend-inner-icon="mdi-magnify" label="Search" single-line
            v-model="searchQuery" />
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="7">
        <event-filters :filterDialog="filterDialog" :filterTypeModality="filterTypeModality"
          :filterTypeModalityList="filterTypeModalityList" :filterFrequency="filterFrequency"
          :filterFrequencyList="filterFrequencyList" :dates="dates" :filterModality="filterModality"
          :filterModalityList="filterModalityList" :filterTypeEvent="filterTypeEvent"
          :filterTypeEventList="filterTypeEventList" :filterLanguage="filterLanguage" :LanguageList="LanguageList"
          @update:filterDialog="filterDialog = $event" @update:filterTypeModality="filterTypeModality = $event"
          @update:filterFrequency="filterFrequency = $event" @update:dates="dates = $event"
          @update:filterModality="filterModality = $event" @update:filterTypeEvent="filterTypeEvent = $event"
          @update:filterLanguage="filterLanguage = $event" @cleanFilter="cleanFilter"
          @saveFilters="handleSaveFilters" />
      </v-col>
    </v-row>

    <!-- Data Table -->
    <event-table :headers="headers" :items="GetEventAndGroup" :page="page" :pageCount="pageCount"
      :itemsPerPage="itemsPerPage" :ItemsPerPageItems="ItemsPerPageItems" :tableLoader="tableLoader"
      @update:page="page = $event" @update:itemsPerPage="itemsPerPage = $event; handleItemPerPage()"
      @previewEvent="PreviewEvent" @editEvent="OpenEditEventDialog" @deleteEvent="ConfirmDelete" />

    <!-- Edit Dialog -->
    <v-dialog v-model="EditEventDialog" persistent max-width="600">
      <v-card v-if="EditEventDialog">
        <EditEventAndGroupComponent :EditEventDialog="EditEventDialog" :setDataStudyGroup="EditEventItem"
          @close="handleClose" />
      </v-card>
    </v-dialog>

    <!-- Preview Dialog -->
    <event-preview :Previewdialog="Previewdialog" :previewDetails="previewDetails"
      @update:Previewdialog="Previewdialog = $event" />

    <!-- Delete Dialog -->
    <delete-event :dialog="dialog" :deleteId="deleteId" :deleteLocation="deleteLocation" :btnloader="btnloader"
      @update:dialog="dialog = $event" @deleteConfirmed="DdialogClose" />
  </div>
</template>

<script>
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import EventAndGroupComponent from "../../components/EventAndGroup/AddEventAndGroup.component.vue";
import EditEventAndGroupComponent from "../../components/EventAndGroup/EditEventAndGroup.component.vue";
import EventFilters from "../../components/EventAndGroup/EventFilters.component.vue";
import EventTable from "../../components/EventAndGroup/EventTable.component.vue";
import EventPreview from "../../components/EventAndGroup/EventPreview.component.vue";
import DeleteEvent from "../../components/EventAndGroup/DeleteEvent.component.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SuccessToastComponent,
    ErrorToastComponent,
    EventAndGroupComponent,
    EditEventAndGroupComponent,
    EventFilters,
    EventTable,
    EventPreview,
    DeleteEvent,
  },
  data() {
    return {
      filtersArray: [],
      dates: [],
      EditEventItem: [],
      filterLanguage: [],
      addEventDialog: false,
      filterTypeEvent: [],
      filterTypeEventList: [
        "Study Group",
        "Public Talk",
        "Expo",
        "Other Event",
        "Get-together",
      ],
      filterModality: [],
      filterModalityList: [
        "Access",
        "BodyTalk",
        "BodyTalk for Animals",
        "BreakThrough",
        "MindScape",
        "FreeFall",
        "PaRama",
        "Open",
      ],
      LanguageList: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      filterFrequency: [],
      filterFrequencyList: ["Recurring Event", "One-Time Event"],
      searchQuery: "",
      searchTimer: null,
      filterTypeModality: [],
      filterTypeModalityList: [
        { name: "Online", id: 2 },
        { name: "In-Person", id: 1 },
      ],
      filterDialog: false,
      Previewdialog: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      SuccessToast: false,
      ErrorToast: false,
      EditEventDialog: false,
      btnloader: false,
      tableLoader: false,
      dialog: false,
      deleteId: 0,
      deleteLocation: "",
      filterObj: {},
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Location", value: "LocationAddress" },
        { text: "Date", value: "EventDate" },
        { text: "Modality", value: "Modality" },
        { text: "Type", value: "Type" },
        { text: "", value: "actions", sortable: false },
      ],
      downloadDataTableOne: [],
      setDataStudyGroup: [],
      previewDetails: {
        Id: null,
        Description: "",
        EventDate: "",
        LocationTitle: "",
        LocationAddress: "",
        Modality: "",
        Type: "",
        TimeZone: "",
        EventLocationType: 0,
        UrlLink: "",
        Language: "",
        HostName: "",
        HostEmail: "",
        HostPhoneNumber: "",
        OccurrenceType: "",
        RecurringDetails: null,
        TimeEnd: "",
        TimeStart: "",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    handleClose({ shouldRefresh }) {
      this.close();
      if (shouldRefresh) {
        this.fetchData();
      }
    },
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    formatDate(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString();
      }
      return "";
    },
    handleSaveFilters(filters) {
      this.filterTypeModality = filters.filterTypeModality;
      this.filterFrequency = filters.filterFrequency;
      this.dates = filters.dates;
      this.filterModality = filters.filterModality;
      this.filterTypeEvent = filters.filterTypeEvent;
      this.filterLanguage = filters.filterLanguage;
      this.page = 1;
      this.fetchData();
    },
    async OpenEditEventDialog(item) {
      try {
        this.tableLoader = true;
        const res = await this.$store.dispatch("GetEventById", item.Id);
        this.EditEventItem = res;
        this.EditEventDialog = true;
        this.tableLoader = false;
      } catch (error) {
        console.error("Error fetching event for edit:", error);
        this.ErrorToast = true;
        this.tableLoader = false;
        setTimeout(() => {
          this.ErrorToast = false;
        }, 3000);
      }
    },
    async ConfirmDelete(item) {
      this.deleteId = item.Id;
      this.deleteLocation = item.EventLocationType == 1 ? item.LocationAddress : item.UrlLink;
      this.dialog = true;
    },
    async PreviewEvent(item) {
      try {
        this.tableLoader = true;
        const eventData = await this.$store.dispatch("GetEventById", item.Id);
        this.previewDetails = {
          Id: eventData.Id,
          LocationTitle: eventData.LocationTitle,
          LocationAddress: eventData.LocationAddress,
          Modality: eventData.Modality,
          Type: eventData.Type,
          TimeZone: eventData.TimeZone,
          EventLocationType: eventData.EventLocationType,
          UrlLink: eventData.UrlLink,
          Language: eventData.Language,
          HostName: eventData.HostName,
          HostEmail: eventData.HostEmail,
          HostPhoneNumber: eventData.HostPhoneNumber,
          OccurrenceType: eventData.OccurrenceType,
          RecurringDetails: eventData.RecurringDetails,
          TimeEnd: eventData.TimeEnd,
          TimeStart: eventData.TimeStart,
          Description: eventData.Description || "",
          EventDate: this.formatDate(eventData.EventDate),
        };
        this.Previewdialog = true;
        this.tableLoader = false;
      } catch (error) {
        console.error("Error fetching event details:", error);
        this.ErrorToast = true;
        this.tableLoader = false;
        setTimeout(() => {
          this.ErrorToast = false;
        }, 3000);
      }
    },
    cleanFilter() {
      this.filterTypeEvent = [];
      this.filterModality = [];
      this.filterFrequency = [];
      this.filterTypeModality = [];
      this.filterLanguage = [];
      this.dates = [];
      this.page = 1;
      // this.fetchData();
    },
    async DdialogClose() {
      this.btnloader = true;
      try {
        await this.$store.dispatch("DeleteEventAndGroup", this.deleteId);
        this.dialog = false;
        this.btnloader = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Event Deleted Successfully",
          showConfirmButton: false,
          timer: 2500,
        });
        this.fetchData();
      } catch (error) {
        console.error("Error deleting event:", error);
        this.btnloader = false;
        this.ErrorToast = true;
        setTimeout(() => {
          this.ErrorToast = false;
        }, 3000);
      }
    },
    close() {
      this.addEventDialog = false;
      this.EditEventDialog = false;
      this.Previewdialog = false;
      this.dialog = false;
      this.filterDialog = false;
      this.SuccessToast = false;
      this.ErrorToast = false;
    },
    async fetchData() {
      const requestData = {
        PageNo: this.page,
        Size: this.itemsPerPage === "All" ? 10000 : this.itemsPerPage,
        IsPagination: this.itemsPerPage !== "All",
        Search: this.searchQuery || "",
        EventLocationType: this.filterTypeModality,
        OccurrenceType: this.filterFrequency,
        Modality: this.filterModality,
        Type: this.filterTypeEvent,
        Language: this.filterLanguage,
        SortBy: "EventDate",
        SortDirection: "asc",
      };
      if (this.dates.length === 2) {
        requestData.StartDate = new Date(this.dates[0]).toISOString();
        requestData.EndDate = new Date(this.dates[1]).toISOString();
      }
      this.tableLoader = true;
      try {
        const response = await this.$store.dispatch("GetEventAndGroup", requestData);
        const totalRecords = response.totalRecords || response?.length || 0;
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(totalRecords / this.itemsPerPage);
          if (this.page > this.pageCount && this.pageCount > 0) {
            this.page = 1;
          }
        } else {
          this.pageCount = 1;
          this.page = 1;
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        this.ErrorToast = true;
        setTimeout(() => {
          this.ErrorToast = false;
        }, 3000);
      } finally {
        this.tableLoader = false;
      }
    },
  },
  computed: {
    ...mapGetters(["GetEventAndGroup"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All" ? this.GetEventAndGroup.length : this.itemsPerPage;
    },
  },
  watch: {
    searchQuery() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.fetchData();
      }, 700);
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  color: rgba(34, 34, 34, 1);
}

.gray {
  color: #646464;
}

.previewHeading {
  font-family: "DM Sans";
  font-size: 24px;
  font-weight: 700;
}

@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}

.v-text-field--outlined>>>fieldset {
  border-color: #e0e0e0;
}
</style>